import { Component } from '@angular/core';

import { AboutPage } from '../about/about';
import { ContactPage } from '../contact/contact';
import { HomePage } from '../home/home';
import { InboxPage } from '../inbox/inbox';
import { CalendarPage } from '../calendar/calendar';
import { ProjectsPage } from '../projects/projects';
import { ExpensePage } from '../expense/expense';


@Component({
  templateUrl: 'tabs.html'
})
export class TabsPage {

  tab1Root = HomePage;
  tab2Root = AboutPage;
  tab3Root = ContactPage;
  tab4Root = CalendarPage;
  tab5Root = InboxPage;
  tab6Root = ProjectsPage;
  tab7Root = ExpensePage;

  constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts